import { decodeEntities } from '@wordpress/html-entities';

const { registerPaymentMethod } = window.wc.wcBlocksRegistry
const paymentGateways = window.wc.wcSettings.allSettings.paymentMethodData;

if (paymentGateways.hasOwnProperty('tochka')) {
    const settings = paymentGateways['tochka']
    const label = decodeEntities( settings.title )
    console.log(settings);

    const Content = () => {
        return decodeEntities( settings.description || '' )
    }

    const Icon = () => {
        return settings.icon
            ? <img src={settings.icon} style={{ float: 'right', marginRight: '20px' }}  alt={settings.title}/>
            : ''
    }

    const Label = ( props ) => {
        const { PaymentMethodLabel } = props.components
        return (
            <span style={{ width: '100%' }}>
                    <PaymentMethodLabel text={ label } />
                <Icon />
                </span>
        )
    }

    registerPaymentMethod( {
        name: 'tochka',
        label: <Label />,
        content: <Content />,
        edit: <Content />,
        canMakePayment: () => true,
        ariaLabel: label,
        supports: {
            features: settings.supports,
        }
    } )
}
